import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'

const TeamItemModal = ({ team, selectedMemberIndex, modalId }) => {
  const [modalSelectedMemberIndex, setModalSelectedMemberIndex] =
    useState(selectedMemberIndex)

  useEffect(() => {
    setModalSelectedMemberIndex(selectedMemberIndex)
  }, [selectedMemberIndex])

  const showNextMember = () => {
    const nextIndex = (modalSelectedMemberIndex + 1) % team.length
    setModalSelectedMemberIndex(nextIndex)
  }

  const showPrevMember = () => {
    const prevIndex = (modalSelectedMemberIndex - 1 + team.length) % team.length
    setModalSelectedMemberIndex(prevIndex)
  }

  return (
    <div className="modal fade" id={modalId} tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body p-2 ps-lg-7 pe-lg-4 pb-lg-4 pt-2 pt-lg-3">
            <div className="row">
              <div className="col-12 text-end">
                <span
                  className="d-inline-block cursor-pointer modal-close mb-1 mb-lg-0"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="lpi lpi-close-thin" />
                </span>
              </div>
              <div className="col-lg-auto">
                {team?.[modalSelectedMemberIndex]?.image && (
                  <span className="our-team-item__image-wrapper our-team-item__image-wrapper--modal ratio ratio-1x1 overflow-hidden d-block mb-4">
                    {parse(team?.[modalSelectedMemberIndex]?.image)}
                  </span>
                )}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  {team?.[modalSelectedMemberIndex]?.position && (
                    <p className="col m-0 text--uppercase pe-2 pe-lg-0">
                      {parse(team[modalSelectedMemberIndex]?.position)}
                    </p>
                  )}
                  {team?.length > 1 && (
                    <ul className="our-team-modal__arrows list-unstyled d-flex d-lg-none">
                      <li>
                        <span
                          className="our-team-modal__arrow d-inline-block cursor-pointer"
                          onClick={showPrevMember}
                        >
                          <i className="lpi lpi-arrow-left-thin" />
                        </span>
                      </li>
                      <li>
                        <span
                          className="our-team-modal__arrow d-inline-block cursor-pointer"
                          onClick={showNextMember}
                        >
                          <i className="lpi lpi-arrow-right-thin" />
                        </span>
                      </li>
                    </ul>
                  )}
                </div>
                {team[modalSelectedMemberIndex]?.title && (
                  <h4 className="our-team-item__name mb-2 text--uppercase">
                    {parse(team[modalSelectedMemberIndex]?.title)}
                  </h4>
                )}
                {team[modalSelectedMemberIndex]?.linkedin_url && (
                  <p className="mb-0 mb-lg-2">
                    <a
                      className="our-team-item__social color--black text-decoration-none d-inline-flex align-items-center"
                      href={team[modalSelectedMemberIndex]?.linkedin_url}
                    >
                      <i className="lpi lpi-linkedin" />
                      <span className="fw-medium d-inline-block">
                        {team[modalSelectedMemberIndex]?.linkedin_text}
                      </span>
                    </a>
                  </p>
                )}
                {team?.length > 1 && (
                  <ul className="our-team-modal__arrows list-unstyled d-none d-lg-flex">
                    <li>
                      <span
                        className="our-team-modal__arrow d-inline-block cursor-pointer"
                        onClick={showPrevMember}
                      >
                        <i className="lpi lpi-arrow-left-thin" />
                      </span>
                    </li>
                    <li>
                      <span
                        className="our-team-modal__arrow d-inline-block cursor-pointer"
                        onClick={showNextMember}
                      >
                        <i className="lpi lpi-arrow-right-thin" />
                      </span>
                    </li>
                  </ul>
                )}
              </div>

              {team[modalSelectedMemberIndex]?.content && (
                <div className="col-lg pt-3 pt-lg-5">
                  <div className="modal-body-scrollbar content-wrapper">
                    {parse(team[modalSelectedMemberIndex]?.content)}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

TeamItemModal.propTypes = {
  team: PropTypes.array,
  selectedMemberIndex: PropTypes.number,
  modalId: PropTypes.string,
}

export default TeamItemModal
